// import moment from '@/plugins/moment';
import { toCamelCaseProperties } from '@fixit/utils';

export default class Order {
	constructor(args) {
		args = toCamelCaseProperties(args) || {};
        this.appointmentId = args.appointmentId || ''
        this.appointmentDate = args.appointmentDate || ''
        this.appointmentStartTime = args.appointmentStartTime || ''
        this.revenue = args.revenue || 0
        this.orderHistoryType = args.orderHistoryType || null
        this.appointmentEmployeeId = args.appointmentEmployeeId || ''
        this.customerId = args.customerId || ''
        this.siteId = args.siteId || 0
        this.siteName = args.siteName || ''
        this.urlSafeSiteName = args.urlSafeSiteName || args.siteName.toLowerCase().replace(' ', '-')
        this.appointmentStatus = setAppointmentType(args.orderHistoryType) || ''
        this.base64AppointmentId = args.base64AppointmentId || ''
        this.fairPayStatus = setFairPayStatus(args.fairPayStatus || 0)
        this.actualFee = args.actualFee || null
        this.fairPayType = setFairPayType(args.fairPayType) || null
        this.treatmentsOrdered = args.treatmentsOrdered || 0
        this.productsOrdered = args.productsOrdered || 0
	}

	assign(order) {
		Object.assign(this, toCamelCaseProperties(order));
	}
}
function setFairPayStatus(orderHistoryType) {
    switch (orderHistoryType) {
        case 0: return 'UNKNOWN'; 
        case 1: return 'NEW'
        case 2: return 'REMINDER1'
        case 3: return 'REMINDER2'
        case 4: return 'PARDONED'
        case 5: return 'PAID'
    }
}

function setFairPayType(fairPayType) {
    switch (fairPayType) {
        case 0: return 'UNKNOWN'; 
        case 1: return 'CANCELLATION'
        case 2: return 'DELETED_AT_SITE'
        case 3: return 'FAIRPAY'
        case 4: return 'MOVE_APPOINTMENT'
    }
}

function setAppointmentType(orderHistoryType) {
    switch (orderHistoryType) {
        case 0: return ''; 
        case 1: return 'future-visit'
        case 2: return 'previous-visit'
        case 3: return 'cancelled'
        case 4: return 'noshow'
    }
}
